import { config } from "../../constants/config";
import { getAssetVideoUrl } from "../../webapi/webapi";

export function millisecondsToSMPTE(milliseconds, fps) {
  var seconds = milliseconds / 1000;
  var frameNumber = Number(seconds * fps);
  function wrap(n) {
    return n < 10 ? "0" + n : n;
  }
  var _hour = fps * 60 * 60,
    _minute = fps * 60;
  var _hours = (frameNumber / _hour).toFixed(0);
  var _minutes = Number((frameNumber / _minute).toString().split(".")[0]) % 60;
  var _seconds = Number((frameNumber / fps).toString().split(".")[0]) % 60;
  var SMPTE =
    wrap(_hours) +
    ":" +
    wrap(_minutes) +
    ":" +
    wrap(_seconds) +
    ":" +
    wrap(frameNumber % fps);
  return SMPTE;
}

export function compareValues(key, order = "asc") {
  return function innerSort(a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
    const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order === "desc" ? comparison * -1 : comparison;
  };
}

export function secondsToTime(seconds) {
  if (seconds) {
    function wrap(n) {
      return n < 10 ? "0" + n : n;
    }
    var date = new Date(seconds * 1000);
    date = new Date(date.toISOString().slice(0, -1));
    var Time =
      wrap(date.getHours()) +
      ":" +
      wrap(date.getMinutes()) +
      ":" +
      wrap(date.getSeconds());
    return Time;
  } else {
    return;
  }
}

export function formatBytes(a, b) {
  if (0 === a) return "0 Bytes";
  var c = 1024,
    d = b || 2,
    e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    f = Math.floor(Math.log(a) / Math.log(c));
  return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f];
}

var illegalRe = /[/?<>\\:*|"]/g;
var controlRe = /[\x00-\x1f\x80-\x9f]/g;
var reservedRe = /^\.+$/;
var windowsReservedRe = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i;
var windowsTrailingRe = /[. ]+$/;

export function sanitize(input, replacement) {
  var sanitized = input
    .replace(illegalRe, replacement)
    .replace(controlRe, replacement)
    .replace(reservedRe, replacement)
    .replace(windowsReservedRe, replacement)
    .replace(windowsTrailingRe, replacement);
  return sanitized;
}

export function checkFileIsAudio(fileName) {
  if (fileName) {
    let re = /(?:\.([^.]+))?$/;
    let ext = re.exec(fileName.toLowerCase())[1];
    let audioFileTypes = ["wav", "mp3", "aiff"];
    return audioFileTypes.includes(ext);
  }
  return false;
}

export function getAssetTypeByFileName(fileName) {
  switch (mediaTypeByExtention(fileName)) {
    case "video":
      return 0;
    case "audio":
      return 1;
    default:
      return -1;
  }
}

export function mediaTypeByExtention(fileName) {
  if (fileName) {
    if (checkFileValidForFilter(fileName, 1)) {
      return "audio";
    }
    if (checkFileValidForFilter(fileName, 0)) {
      return "video";
    }
  } else {
    return "";
  }
}

// -1 check all
export function checkFileValidForFilter(fileName, fileType = -1) {
  if (fileName) {
    let re = /(?:\.([^.]+))?$/;
    let ext = re.exec(fileName.toLowerCase())[1];
    const audioFilter = ["wav", "mp3", "aac"];
    const videoFilter = ["mp4", "mov", "mxf"];
    const allMediaFilter = [...audioFilter, ...videoFilter];
    switch (fileType) {
      case 0:
        return videoFilter.includes(ext);
      case 1:
        return audioFilter.includes(ext);

      default:
        return allMediaFilter.includes(ext);
    }
  }
  return false;
}

export function getAudioFileFilter() {
  return ".wav,.mp3,.aac";
}

export function getVideoFileFilter() {
  return ".mp4,.mov,.mxf";
}

export function getAllMediaFileFilter() {
  return ".mp4,.mov,.mxf,.wav,.mp3,.aac";
}

export function getAudioMimeFilter() {
  return {
    valid: [".wav", ".mp3", ".aac"]
  };
}

export function getVideoMimeFilter() {
  return {
    valid: [".mp4", ".mov", ".mxf"]
  };
}

export function getAllMediaMimeFilter() {
  return {
    valid: [".mp4", ".mov", ".mxf", ".wav", ".mp3", ".aac"]
  };
}

export function getMimeFilterForAssetType(assetType) {
  switch (assetType) {
    case 0:
      return getVideoMimeFilter();
    case 1:
      return getAudioMimeFilter();
    default:
      return getAllMediaMimeFilter();
  }
}

export function getCreationDateFromBCMVideoMetadata(metadata) {
  if (metadata.creationDate) {
    const dateString = metadata.creationDate
      .replace("/Date(", "")
      .replace(")", "");
    const date = new Date(parseInt(dateString, 10));
    if (date instanceof Date && !isNaN(date)) {
      const stringDate = getStringDate(date);
      return `${stringDate.substring(0, 10)} ${stringDate.substring(11, 19)}`;
    }
  }

  return "";
}

export function getStringDate(date) {
  let month = String(date.getMonth() + 1).padStart(2, "0");
  let day = String(date.getDate()).padStart(2, "0");
  let year = date.getFullYear();
  let hours = String(date.getHours()).padStart(2, "0");
  let minutes = String(date.getMinutes()).padStart(2, "0");
  let seconds = String(date.getSeconds()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000Z`;
}

const videoAssetIds = [0, 2];
const audioAssetIds = [1, 3];
const localAssetIds = [0, 1];
const rssFeedItems = [2, 3];

export function getVideoAssetTypeIds() {
  return videoAssetIds.map(a => a.toString());
}

export function getAudioAssetTypeIds() {
  return audioAssetIds.map(a => a.toString());
}

export function getAssetMediaType(assetTypeId) {
  if (videoAssetIds.includes(assetTypeId)) {
    return 0;
  }

  if (audioAssetIds.includes(assetTypeId)) {
    return 1;
  }
  return 0;
}

export function isAssetMediaLocal(assetTypeId) {
  return localAssetIds.includes(assetTypeId);
}

function isMediaAvailable(mediaType, asset) {
  switch (mediaType) {
    case 0: //video
      return asset.Status !== "processing" && asset.Status !== "replacing";
    case 1: //audio
      // return asset.Audio.Source.FileStatus === "ready";
      return asset.Status !== "processing" && asset.Status !== "replacing";
    default:
      break;
  }
}

function hasMedia(mediaType, asset) {
  switch (mediaType) {
    case 0: //video
      return asset.Status !== "no-video";
    case 1: //audio
    default:
      return true;
  }
}

function isMediaProcessing(mediaType, asset) {
  switch (mediaType) {
    case 0: //video
      return asset.Status === "processing" || asset.Status === "replacing";
    case 1: //audio
      return asset.Status === "processing" || asset.Status === "replacing";
    default:
      return false;
  }
}

function isMediaReady(mediaMetadata) {
  return mediaMetadata.FileStatus === "ready";
}

function getMediaDuration(mediaMetadata, mediaType) {
  return mediaMetadata.Duration
    ? secondsToTime(mediaMetadata.Duration || 0)
    : "";
}

function getMediaThumbnail(isLocal, mediaMetadata) {
  if (isLocal && mediaMetadata.Thumbnail) {
    return config.IMAGE_URL + mediaMetadata.Thumbnail + "?c=" + Date.now();
  } else {
    return mediaMetadata.Thumbnail;
  }
}

function mediaHasError(assetStatus) {
  return assetStatus === "error";
}

export function getMediaMetadataProxy(mediaType, asset) {
  switch (mediaType) {
    case 0: //video
      return asset.Video.Proxy;
    case 1: //audio
      return asset.Audio.Proxy;
    default:
      return "";
  }
}

function getMediaMetadataSource(mediaType, asset) {
  switch (mediaType) {
    case 0: //video
      return asset.Video.Source;
    case 1: //audio
      return asset.Audio.Source;
    default:
      return null;
  }
}

function getMediaFileName(isLocal, mediaMetadata) {
  if (isLocal) {
    return config.VIDEO_URL + mediaMetadata.FileStorageLocation;
  } else {
    return mediaMetadata.FileStorageLocation;
  }
}
export function isRssFeed(assetTypeId) {
  return rssFeedItems.includes(assetTypeId);
}

export function getAssetMediaInfo(asset) {
  let mediaInfo = {};
  mediaInfo.localSource = isAssetMediaLocal(asset.AssetTypeID);
  mediaInfo.mediaType = getAssetMediaType(asset.AssetTypeID);
  mediaInfo.mediaMetadataProxy = getMediaMetadataProxy(
    mediaInfo.mediaType,
    asset
  );
  mediaInfo.mediaMetadataSource = getMediaMetadataSource(
    mediaInfo.mediaType,
    asset
  );

  mediaInfo.hasMedia = hasMedia(mediaInfo.mediaType, asset);
  mediaInfo.isMediaAvailable =
    mediaInfo.hasMedia && isMediaAvailable(mediaInfo.mediaType, asset);
  mediaInfo.thumbnail = getMediaThumbnail(
    mediaInfo.localSource,
    mediaInfo.mediaMetadataProxy
  );
  mediaInfo.mediaUrl = getMediaFileName(
    mediaInfo.localSource,
    mediaInfo.mediaMetadataProxy
  );
  mediaInfo.fileDuration = getMediaDuration(
    mediaInfo.mediaMetadataProxy,
    mediaInfo.mediaType
  );
  mediaInfo.hasError = mediaHasError(asset.Status);
  mediaInfo.isMediaReady =
    isMediaReady(mediaInfo.mediaMetadataSource) || !mediaInfo.localSource;
  mediaInfo.isMediaProcessing = isMediaProcessing(mediaInfo.mediaType, asset);
  mediaInfo.isRssFeed = isRssFeed(asset.AssetTypeID);
  return mediaInfo;
}

export function getTruncatedFilename(filename, length) {
  if (!filename) return "";
  if (filename.length < length) return filename;
  const extention = filename.substring(filename.length - 3);
  const suffix = `...${extention}`;
  return `${filename.substring(0, filename.length - suffix.length)}${suffix}`;
}

export function getTruncatedFilename_better_logic(filename, length) {
  if (!filename) return "";
  if (filename.length < length) return filename;

  const lastdotindex = filename.lastIndexOf(".");
  if (lastdotindex === -1) return filename;
  const extention = filename.substr(lastdotindex);
  let filenamepart = filename.substr(0, lastdotindex).substr(0, length);

  return `${filenamepart}...${extention}`;
}
